import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import {FormBuilder, FormControl, Validators} from '@angular/forms';
import {MatDialog, MatDialogRef, MatOption, MatSelect, MatStepper} from '@angular/material';
import {DelegationListComponent} from '../delegation-list/delegation-list.component';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {DelegationUo, TypeSelectDelegation} from '../delegation.model';
import {DelegationService} from '../delegation.service';

@Component({
  selector: 'app-select-delegation',
  templateUrl: './select-delegation.component.html',
  styleUrls: ['./select-delegation.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SelectDelegationComponent implements OnInit, AfterViewInit {

  constructor(private _formBuilder: FormBuilder,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<DelegationListComponent>,
              private delegationService: DelegationService) { }


  @Input()
  iconName;
  @Input()
  selectItems: any[];

  @Input()
  selectedDelagtor;

  @Input()
  selectLabel;

  @Input()
  user;

  @Output() selectEmitter = new EventEmitter<any>();

  searchItems = '';

  searchProperties: string[] = [];

  preventSelectOpen = false;

  @ViewChild('select') select: MatSelect;
  allSelected = false;

  uoDefaultList: any [];





  ngOnInit() {
    if (this.selectLabel === TypeSelectDelegation.COLLABORATORS) {
      this.searchProperties = ['matricule', 'fullName', 'job'];
    } else if (this.selectLabel === TypeSelectDelegation.UO) {
      this.searchProperties = ['label', 'name', 'uoId'];
    }
  }
  // Event fired after view is initialized
  ngAfterViewInit() {

  }


  toggleSelection(): void {
    if (this.allSelected) {
      this.user.setValue([...this.selectItems]);
      this.select.options.forEach((item: MatOption) => item.select());
    } else {
      this.user.setValue([]);
      this.select.options.forEach((item: MatOption) => item.deselect());
    }
  }

  optionClick() {
    let newStatus = true;
    this.select.options.forEach((item: MatOption) => {
      if (!item.selected) {
        newStatus = false;
      }
    });
    this.allSelected = newStatus;
  }

  onToppingRemoved(topping: string) {
    this.preventSelectOpen = true;
    const toppings = this.user.value as string[];
    this.removeFirst(toppings, topping);
    this.user.setValue(toppings);
    setTimeout(() => {
      this.preventSelectOpen = false;
    }, 100); // Adjust the delay as needed
  }

  private removeFirst<T>(array: T[], toRemove: T): void {
    const index = array.indexOf(toRemove);
    if (index !== -1) {
      array.splice(index, 1);
    }
  }

  emitUserData() {
    this.selectEmitter.emit(this.user);
  }


  protected readonly TypeSelectDelegation = TypeSelectDelegation;
}



// WEBPACK FOOTER //
// ./src/app/modules/delegation/select-delegation/select-delegation.component.ts